import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { doc, setDoc } from "firebase/firestore";
import { ReactComponent as VeryGood } from "../../assets/icons/very-good.svg";
import { ReactComponent as Good } from "../../assets/icons/good.svg";
import { ReactComponent as Soso } from "../../assets/icons/soso.svg";
import { ReactComponent as Poor } from "../../assets/icons/poor.svg";
import { ReactComponent as VeryPoor } from "../../assets/icons/very-poor.svg";
import { ReactComponent as Back } from "../../assets/icons/back.svg";
import { ReactComponent as Check } from "../../assets/icons/greenCheck.svg";
import { db } from "../../utils/firebase";
import { useNavigate } from "react-router";

function ReviewForm({ thisUser }) {
  const selectedTutor = useSelector((state) => state.selectedTutor.tutor);
  const [rating, setRating] = useState(null);
  const [review, setReview] = useState("");
  const [reviewReady, setReviewReady] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (document.getElementById("review-content-form")) {
      document.getElementById("review-content-form").scrollIntoView({
        behavior: "smooth",
      });
    }
  }, [reviewReady]);

  useEffect(() => {
    if (document.getElementById("reviewform-top")) {
      document.getElementById("reviewform-top").scrollIntoView({
        behavior: "smooth",
      });
    }
  }, [selectedTutor]);

  useEffect(() => {
    setRating(null);
    setReview("");
    setReviewReady(false);
  }, [selectedTutor]);

  useEffect(() => {
    if (document.getElementById("review-textarea")) {
      var textarea = document.getElementById("review-textarea");

      textarea.addEventListener("keydown", autosize);

      function autosize() {
        var el = this;
        setTimeout(function () {
          el.style.cssText = "height:auto; padding:0";
          el.style.cssText = "-moz-box-sizing:content-box";
          el.style.cssText = "height:" + el.scrollHeight + "px";
        }, 0);
      }
    }
  }, [review]);

  const getUpdatedRating = (reviewCount, newRating, tutor) => {
    if (reviewCount === 0) {
      return newRating;
    } else {
      let oldRating = 0;
      tutor.reviews.reviewers.forEach((reviewer) => {
        oldRating += reviewer.rating;
      });
      let newUpdatedRating = parseFloat(
        (oldRating + newRating) / (reviewCount + 1)
      );
      // SG 08/05/2022 18:32  dropping extra zeros at the end
      newUpdatedRating = +newUpdatedRating.toFixed(2);
      return newUpdatedRating;
    }
  };

  const handleReviewSubmit = (withoutComment) => {
    //TODO: SG 08/05/2022 18:00  check review length
    const thisTutorRef = doc(db, "tutors", selectedTutor.id);
    const reviewerName = `${thisUser?.firstName} ${thisUser.lastName}`;
    const postedBy = thisUser.id;
    const profileImagePath = thisUser.picturePath;
    const newReviewCount = selectedTutor.reviews?.count + 1;
    const updatedNewRating = getUpdatedRating(
      selectedTutor.reviews.count,
      rating,
      selectedTutor
    );

    if (!withoutComment) {
      const reviewContents = {
        name: reviewerName,
        postedBy: postedBy,
        profileImagePath: profileImagePath,
        rating: rating,
        reviewContent: review,
      };
      setDoc(
        thisTutorRef,
        {
          // reviews: [reviewContents, ...selectedTutor.reviews],
          rating: updatedNewRating,
          reviews: {
            reviewers: [
              ...selectedTutor.reviews?.reviewers,
              {
                id: thisUser.id,
                rating: rating,
                reviewContents: reviewContents,
              },
            ],
            count: newReviewCount,
          },
        },
        { merge: true }
      )
        .then(() => {
          navigate("/review-success");
        })
        .catch((e) => console.log(e));
    } else {
      setDoc(
        thisTutorRef,
        {
          rating: updatedNewRating,
          reviews: {
            reviewers: [
              ...selectedTutor.reviews?.reviewers,
              {
                id: thisUser.id,
                rating: rating,
              },
            ],
            count: newReviewCount,
          },
        },
        { merge: true }
      )
        .then(() => {
          navigate("/review-success");
        })
        .catch((e) => console.log(e));
    }
  };

  if (!selectedTutor) return null;

  return (
    <div className="px-10 pt-20 h-screen w-screen" id="reviewform-top">
      <p className="text-[1.8em] md:text-[2em] font-medium text-gray-700">
        How was your experience with {selectedTutor.firstName}?
      </p>
      <p
        className={`${
          rating
            ? "text-[1.5em] font-semibold text-gray-700 mt-5"
            : "text-[0px]"
        }`}
      >
        {(rating === 5 && '"Very Good"') ||
          (rating === 4 && '"Good"') ||
          (rating === 3 && '"Alright"') ||
          (rating === 2 && '"Poor"') ||
          (rating === 1 && '"Very Poor"')}
      </p>
      <div className="flex w-full justify-start items-center flex-wrap">
        <div
          className={`flex mt-10 w-[80%] md:w-fit h-[3em] justify-start ${
            rating ? "w-fit" : "gap-3"
          }`}
        >
          <VeryPoor
            className={`w-[5em] md:w-[3.5em] cursor-pointer hover:scale-[1.1] transition-all duration-300 ease-in-out ${
              rating && rating !== 1 && "w-0 md:w-0"
            } `}
            fill="#F6121A"
            onClick={() => setRating(1)}
          />
          <Poor
            className={`w-[5em] md:w-[3.5em] cursor-pointer hover:scale-[1.1] transition-all duration-300 ease-in-out ${
              rating && rating !== 2 && "w-0 md:w-0"
            } `}
            fill="#FA8828"
            onClick={() => setRating(2)}
          />
          <Soso
            className={`w-[5em] md:w-[3.5em] cursor-pointer hover:scale-[1.1] transition-all duration-300 ease-in-out ${
              rating && rating !== 3 && "w-0 md:w-0"
            } `}
            fill="#FBE846"
            onClick={() => setRating(3)}
          />
          <Good
            className={`w-[5em] md:w-[3.5em] cursor-pointer hover:scale-[1.1] transition-all duration-300 ease-in-out ${
              rating && rating !== 4 && "w-0 md:w-0"
            } `}
            fill="#93D552"
            onClick={() => setRating(4)}
          />

          <VeryGood
            className={`w-[5em] md:w-[3.5em] cursor-pointer hover:scale-[1.1] transition-all duration-300 ease-in-out ${
              rating && rating !== 5 && "w-0 md:w-0"
            } `}
            fill="#4DC050"
            onClick={() => setRating(5)}
          />
        </div>
        <Back
          className="scale-[2.5] mt-9 ml-10 cursor-pointer"
          onClick={() => {
            if (!rating) {
              document.getElementById("navbar-top").scrollIntoView({
                behavior: "smooth",
              });
            } else {
              setRating(null);
              setReviewReady(false);
            }
          }}
        />
        {rating && (
          <Check
            className="scale-[2.5] mt-9 ml-10 cursor-pointer"
            onClick={() => {
              setReviewReady(true);
              if (document.getElementById("review-content-form")) {
                document.getElementById("review-content-form").scrollIntoView({
                  behavior: "smooth",
                });
              }
            }}
          />
        )}
      </div>
      {reviewReady && (
        <div
          className="mt-[10em] h-[80vh] md:h-[90vh] flex flex-col"
          id="review-content-form"
        >
          <p className="text-[1.8em] md:text-[2em] font-medium text-gray-700">
            Let us hear your experience
          </p>
          <textarea
            onChange={(e) => {
              setReview(e.target.value);
            }}
            value={review}
            placeholder="Type your feedback here"
            className=" text-[1.3em] outline-none text-gray-800 bg-transparent w-[80vw] max-w-[500px] overflow-hidden py-5  resize-none"
            id="review-textarea"
          />
          {review !== "" ? (
            <button
              className="text-white shadow-lg font-semibold bg-black w-fit p-4 rounded-md transition duration-500 ease-in-out hover:-translate-y-2"
              onClick={() => handleReviewSubmit(false)}
            >
              Submit Review
            </button>
          ) : (
            <div>
              <div className="border-t border-black w-[18em] relative mb-5">
                <p className="absolute top-[-.9em] left-[48%] -translate-x-[50%] bg-white px-3">
                  or
                </p>
              </div>
              <button
                className="text-white shadow-lg mt-4 font-semibold bg-black w-fit p-3 rounded-md transition duration-500 ease-in-out hover:-translate-y-2"
                onClick={() => handleReviewSubmit(true)}
              >
                Submit Rating Without Comment
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ReviewForm;
